import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-file-download",
  "use": "gw-file-download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-file-download\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol